var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourses({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 6.87887C5.22132 7.04222 6.39799 7.31381 7.49984 7.7399M4.1665 10.2122C4.69941 10.2947 5.26342 10.4049 5.83317 10.5486M9.99984 5.04447V16.9187M3.32844 2.50939C5.17709 2.71829 7.66078 3.28027 9.43052 4.52037C9.77065 4.75871 10.229 4.75871 10.5691 4.52037C12.3389 3.28027 14.8226 2.71829 16.6712 2.50939C17.5862 2.40601 18.3332 3.17002 18.3332 4.11265V13.5C18.3332 14.4426 17.5862 15.2069 16.6712 15.3103C14.8226 15.5192 12.3389 16.0811 10.5692 17.3212C10.229 17.5596 9.77065 17.5596 9.43052 17.3212C7.66078 16.0811 5.17709 15.5192 3.32844 15.3103C2.41352 15.2069 1.6665 14.4426 1.6665 13.5V4.11265C1.6665 3.17002 2.41352 2.40601 3.32844 2.50939Z",
    stroke: "#191919",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourses);
export default __webpack_public_path__ + "static/media/courses.33bf7451389e75d67b8150a42f20944b.svg";
export { ForwardRef as ReactComponent };